import { MatrixMapping } from '@mews/b2b-ui';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Service } from '@mews-commander/data-access';
import { getBookablePeriodTextKey } from '@mews-commander/utils';
import { ServiceLink } from '../../../components';

export const bookableServicesMapping: Array<MatrixMapping<Service>> = [
    {
        valueKey: 'names',
        title: <LocalizedText textKey={TextKey.Name} />,
        render: (service) => <ServiceLink service={service} />,
        columnWidth: '40%',
    },
    {
        valueKey: 'ordering',
        title: <LocalizedText textKey={TextKey.Ordering} />,
        columnWidth: '30%',
    },
    {
        valueKey: 'data',
        title: <LocalizedText textKey={TextKey.BookablePeriod} />,
        render: (bookableService) => {
            const textKey = getBookablePeriodTextKey(bookableService);
            return <LocalizedText textKey={textKey} />;
        },
        columnWidth: '30%',
    },
];

export const additionalServicesMapping: Array<MatrixMapping<Service>> = [
    {
        valueKey: 'names',
        title: <LocalizedText textKey={TextKey.Name} />,
        render: (service) => <ServiceLink service={service} />,
        columnWidth: '40%',
    },
    {
        valueKey: 'ordering',
        title: <LocalizedText textKey={TextKey.Ordering} />,
        columnWidth: '60%',
    },
];
